const swiperTimeline = new Swiper(".swiper-timeline", {
  // Optional parameters
  loop: true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 20,

  breakpoints: {
    768: {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 23,
    },
  },

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
